import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Notifications from 'vue-notification';
import Vuelidate from 'vuelidate';
import VTooltip from 'v-tooltip';
import UnsupportBrowsers from './UnsupportBrowsers.vue';
import App from './App.vue';
import router from './router';
import store from './store';

import 'swiper/dist/css/swiper.css';


Vue.use(VueAwesomeSwiper);
Vue.use(VTooltip);
Vue.use(Vuelidate);
Vue.use(Notifications);
Vue.config.productionTip = false;

// Internet Explorer 6-11
const isIE = false || !!document.documentMode;
// Edge 20+
const isEdge = !isIE && !!window.StyleMedia;
if (!isIE && !isEdge) {
  new Vue({
    router,
    store,
    render: h => h(App),
    methods: {
      onBodyScroll() {
        document.body.classList.remove('modal-open');
      },
      offBodyScroll() {
        document.body.classList.add('modal-open');
      },
    },
  }).$mount('#app');
} else {
  new Vue({
    render: h => h(UnsupportBrowsers),
    methods: {
    },
    mounted() {
    },
  }).$mount('#app');
}
